import React from 'react';
import { IImage } from "types/base";
import Link from "components/base/Link";
import { Image } from "react-datocms";
import Button from "components/elements/Button";
import { localIcon } from "components/elements/Icon";
import useTrans from "components/hooks/useTrans";
import { ICustomerCategory } from "pages/customers";
import Text from "components/typography/Text";
import Paragraph from "components/elements/Paragraph";

export type Props = {
    eyebrow?: string,
    slug?: string,
    title: string,
    featuredImage: IImage,
    intro?: any,
};

export default function CustomerCard(props: Props) {
    const { title, eyebrow, intro, featuredImage, slug } = props;
    const { t } = useTrans();

    const Card = () => (
        <div
            className={"flex flex-col gap-4 lg:gap-0 lg:flex-col overflow-hidden p-4 lg:px-4 hover:shadow-xl rounded-xl transition-all ease-in-out"}
        >
            <div className={"bg-white lg:w-full lg:overflow-hidden"}>
                {featuredImage ? (
                    <div className={"group-hover:scale-105 transform transition-transform duration-1000"}>
                        <Image
                            data={featuredImage.responsiveImage}
                            pictureClassName={"h-full object-cover lg:w-full lg:object-scale-down"}
                        />
                    </div>
                ) : (
                    <img
                        alt={"Featured Image"}
                        src={"https://www.tekstmaatje.nl/wp-content/uploads/2020/06/placeholder.png"}
                        className={"object-cover lg:w-full lg:object-scale-down h-full"}
                    />
                )}
            </div>

            <div className={"flex flex-col flex-1"}>
                <Text color={"text-purple"} weight={"medium"} className={"mb-4 mt-4"}>
                    {eyebrow}
                </Text>
                <Text size={"xl"} weight={"normal"}>
                    {title}
                </Text>
                {intro && (
                    <Paragraph renderAs={"structuredText"} className={"opacity-50"}>
                        {intro}
                    </Paragraph>
                )}
                {slug && (
                    <div className={"lg:my-2"}>
                        <Button
                            id={"customer-card__read-full-story"}
                            variant={"link"}
                            size={"large"}
                            color={"purple"}
                            children={t('readMore')}
                            icon={localIcon("arrow-right-2", "")}
                        />
                    </div>
                )}
            </div>
        </div>
    );

    if (slug) {
        return (
            <Link to={slug} className={"group"}>
                <Card/>
            </Link>
        );
    }

    return <Card/>;
}